module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/main/content/Prefijo/MandanteNew.component.html
// module id = ../../../../../src/app/main/content/Prefijo/MandanteNew.component.html
// module chunks = main